import OptionsPanel from "./OptionsPanel"
import Color from "./Color"

export default class BackgroundColor extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Background Color" // TODO: This needs to be localized
    this.setting = "backgroundColor"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }

}
